<template>
    <div class="developer">
        <img :src="Main.imgserve+'/DEVELOPERR/D_intro.png'" alt="">

    <div class="left_imgcontent">
      <h2 style="margin-top: 2vh;text-align: end; width: 80%">DEVELOPER</h2>
      <!-- <div style="text-align: start; width: 80%; margin-left: 10%">
        <h4>THE OASIS</h4>
        <p>Simple intro of the selected images / video.</p>
      </div> -->
    </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    methods:{

    },
    mounted(){

    }
}
</script>

<style lang="less">
    
.developer{
    width: 100%;
    height: 100%;
    margin: auto;
    .left_imgcontent{
        background: none;
    }
    img{
        width: 100%;
    height: 100%;    
    }
}


</style>